import React, { useState } from 'react';
import { ScrapperTabs } from '../components/ScrapperTabs'
import { ScrapperBody } from '../components/ScrapperBody'
import { ScrapperExport } from '../components/ScrapperExport'
import "../css/styles.css"

function Scrapper() {

    const [activeBody, setActiveBody] = useState('scrapper');

    const handleBodyActive = (selectedTab) => {
        setActiveBody(selectedTab);
    };

  return (
    <>
        <div className="Content__scraperForm">
            <div className="container">
                <div className="Content__scraperForm--container">
                    <ScrapperTabs handleBodyActive={handleBodyActive} activeBody={activeBody} />
                    <div className="Content__scraperForm--bodies">
                        <ScrapperBody activeBody={activeBody} />
                        <ScrapperExport activeBody={activeBody} />
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export { Scrapper }